import {Injectable} from '@angular/core';
import {CommonService, CurrentSubject} from './common.service';
import {FaqCategory} from '../model/FaqCategory';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Product} from "../model/product";

@Injectable({
  providedIn: 'root'
})
export class FaqCategoryService extends CommonService<FaqCategory> {
  allcategories: FaqCategory[];
  $allcategories = new CurrentSubject<FaqCategory[]>();

  constructor(http: HttpClient) {
    super(http, '/faq/categories');
    this.http.get<FaqCategory[]>(`${environment.backend}/faq/allcategories`).subscribe(data => {
      this.allcategories = data;
      this.$allcategories.next(this.allcategories);
    });
  }

  getAllCategories(): Observable<FaqCategory[]> {
    return this.$allcategories.asObservable();
  }

  getFromProduct(p: Product): FaqCategory {
    return this.allcategories?.find(c => {
      return c.slug.toLowerCase() === p.tag.toLowerCase();
    });
  }

  getFromString(s: string): FaqCategory {
    return this.allcategories?.find(c => {
      return c.slug.toLowerCase() === s.toLowerCase();
    });
  }
}
